import moment from 'moment';
import qs from 'qs';

import { api } from '../../../../api';
import { bookingJournal } from '../../../../config/api';
import { formatSystemDateTime } from '../../../shared/lib';

export const getActiveInPeriodRequest = (
  restaurantId: number,
  from: moment.Moment,
  till: moment.Moment,
) => {
  const url = `${bookingJournal}/${restaurantId}/order/filter`;

  const params = {
    from: formatSystemDateTime(from),
    to: formatSystemDateTime(till),
    status: ['ACCEPTED', 'CREATED', 'IN_PROGRESS', 'PRE_CHECK', 'ARRIVED'],
  };

  return api
    .get(url, {
      params,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
    .then((r: GM.Orders.Response.Filter) => r);
};
